import {getFromMeta} from 'utils/csrfToken';
import * as actionTypes from 'requests/actionTypes';
import {parseJsonApiRepresentation} from 'requests/responseHandlers/2xx';
import {POST} from 'requests';

const WORKING_SET_TYPEFACE_METHOD_CREATE = 'WORKING_SET_TYPEFACE_METHOD_CREATE';
const WORKING_SET_TYPEFACE_METHOD_UPDATE = 'WORKING_SET_TYPEFACE_METHOD_UPDATE';

function fromDropzone(type, request, record, dropzoneInstance) {
  return (dispatch) => {
    const errors = {family: [], weight: [], style: [], typeface: []};
    const hasErrors = () => errors.family.length > 0 || errors.typeface.length > 0;
    const creating = (request.method === POST);

    /* eslint-disable no-param-reassign */
    dropzoneInstance.options.paramName = 'typeface';
    dropzoneInstance.options.headers = {
      'X-CSRF-Token': getFromMeta(),
    };
    dropzoneInstance.options.url = `/${request.url.join('/')}`;
    dropzoneInstance.options.method = request.method;
    dropzoneInstance.options.params = {
      kit_id: record.kitId,
      family: record.family,
      weight: record.weight,
      style: record.style,
      subsetting: record.subsetting,
      character_sets: (record.characterSets.toArray) ? record.characterSets.toArray() : record.characterSets,
    };
    /* eslint-enable no-param-reassign */

    dispatch({
      type: actionTypes.REQUEST_QUEUED,
      request,
    });

    if (record.family.length === 0) {
      errors.family.push('is required');
    }

    if (dropzoneInstance.files.length === 0 && creating) {
      errors.typeface.push('is required');
    }

    if (hasErrors()) {
      dispatch({
        type: actionTypes.RESPONSE_BAD_REQUEST,
        response: new Response('', {status: 400}),
        request,
        errors,
      });
    } else {
      dropzoneInstance.on('success', (file, json) => {
        dispatch({
          type: (request.method === POST) ? actionTypes.RESPONSE_CREATED : actionTypes.RESPONSE_DATA,
          request,
          response: new Response('', {status: 200}),
          data: parseJsonApiRepresentation(json),
        });
      });
      dropzoneInstance.on('error', (file, json, xhr) => {
        dropzoneInstance.removeAllFiles(true);

        if (xhr.status === 403) {
          dispatch({
            type: actionTypes.RESPONSE_NOT_ALLOWED,
            request,
            response: new Response('', {status: 403}),
          });
        } else if (xhr.status === 400) {
          dispatch({
            type: actionTypes.RESPONSE_BAD_REQUEST,
            request,
            response: new Response('', {status: 400}),
            errors: json.errors,
          });
        } else {
          dispatch({
            type: actionTypes.RESPONSE_FAILURE,
            request,
            response: new Response('', {status: xhr.status}),
          });
        }
      });

      dropzoneInstance.processQueue();
    }

    return request;
  };
}

export function createWorkingSetTypeface(request, record, dropzoneInstance) {
  return fromDropzone(WORKING_SET_TYPEFACE_METHOD_CREATE, request, record, dropzoneInstance);
}

export function updateWorkingSetTypeface(request, record, dropzoneInstance) {
  return fromDropzone(WORKING_SET_TYPEFACE_METHOD_UPDATE, request, record, dropzoneInstance);
}



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/actions/workingSetTypefaces.js